import {LOCAL_STORAGE_MY_NEWS_LAST_ADDED_DATE_KEY} from '../../../config/constants';
import {Maybe, MyNewsItem} from '../../../graphql/generated/types';
import {LOCAL_STORAGE_LAST_MY_NEWS_LIST_KEY} from '../constant';

export function storeMyNewsInfoToLocalStorage({
  myNews,
}: {
  myNews?: Maybe<MyNewsItem[]>;
}) {
  if (!myNews || myNews.length === 0) {
    return;
  }

  const newsIdList = myNews.map(newsItem => newsItem.newsId);

  window.localStorage.setItem(
    LOCAL_STORAGE_LAST_MY_NEWS_LIST_KEY,
    JSON.stringify(newsIdList)
  );

  // 가장 첫 번째 알림 아이템이 가장 최신 알림 아이템입니다.
  window.localStorage.setItem(
    LOCAL_STORAGE_MY_NEWS_LAST_ADDED_DATE_KEY,
    myNews[0].date
  );
}
